import { useState } from 'react';
import { useHistory } from 'react-router';

const defaultDialog = {
  isConfirm: false,
  title: '系統訊息',
  message: '',
  cancelText: '取消',
  confirmText: '確定',
  cancelColor: 'primary',
  confirmColor: 'primary',
  textCenter: false,
  onClose: () => {},
  onCancel: () => {},
  onConfirm: () => {},
  redirectTo: '',
  replaceTo: '',
};

const useProvideDialog = () => {
  const history = useHistory();

  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(defaultDialog);

  const resetDialog = () => {
    setData(defaultDialog);
  };

  const setDialog = ({
    show,
    isConfirm,
    title,
    message,
    cancelText,
    confirmText,
    cancelColor,
    confirmColor,
    textCenter,
    onClose,
    onCancel,
    onConfirm,
    redirectTo,
    replaceTo,
  }) => {
    if (!show) setIsOpen(false);

    const options = {
      isConfirm: isConfirm || defaultDialog.isConfirm,
      title: title || defaultDialog.title,
      message: message || defaultDialog.message,
      cancelText: cancelText || defaultDialog.cancelText,
      confirmText: confirmText || defaultDialog.confirmText,
      cancelColor: cancelColor || defaultDialog.cancelColor,
      confirmColor: confirmColor || defaultDialog.confirmColor,
      textCenter: textCenter || defaultDialog.textCenter,
      onClose: onClose || defaultDialog.onClose,
      onCancel: onCancel || defaultDialog.onCancel,
      onConfirm: onConfirm || defaultDialog.onConfirm,
      redirectTo: redirectTo || defaultDialog.redirectTo,
      replaceTo: replaceTo || defaultDialog.replaceTo,
    };

    setTimeout(
      () => {
        show ? setData(options) : resetDialog();
      },
      show ? 0 : 100
    );

    if (show) setIsOpen(true);
  };

  const openAlert = (options) => {
    setDialog({ show: true, ...options });
  };

  const openConfirm = (options) => {
    setDialog({ show: true, ...options, isConfirm: true });
  };

  const closeDialog = () => {
    setDialog({ show: false });

    if (!data) return;
    if (data.replaceTo) {
      history.replace(data.replaceTo);
    } else if (data.redirectTo) {
      history.push(data.redirectTo);
    }
  };

  const close = () => {
    closeDialog();

    if (data && data.onClose) {
      data.onClose();
      data.onClose = () => {};
    }
  };

  const cancel = () => {
    closeDialog();

    if (data && data.onCancel) {
      data.onCancel();
      data.onCancel = () => {};
    }
  };

  const confirm = () => {
    closeDialog();

    if (data && data.onConfirm) {
      data.onConfirm();
      data.onConfirm = () => {};
    }
  };

  return {
    isOpen,
    data,
    openAlert,
    openConfirm,
    closeDialog,
    close,
    cancel,
    confirm,
  };
};

export default useProvideDialog;
